import type { ComponentChildren } from 'preact';

export interface ConfirmationProps {
  title: string;
  /** Local-time label such as "Tuesday, October 6 at 11:00 AM CDT". */
  when?: string | null;
  subtitle?: string | null;
  joinUrl?: string | null;
  calendar?: { google?: string; outlook?: string; ics?: string } | null;
  children?: ComponentChildren;
}

const Tick = () => (
  <span class="tick" aria-hidden="true">
    <svg
      aria-hidden="true"
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  </span>
);

/** The Google / Outlook / Apple buttons; nothing when there is no link to offer. */
export function CalendarButtons({ cal }: { cal: ConfirmationProps['calendar'] }) {
  if (!cal || !(cal.google || cal.outlook || cal.ics)) return null;
  return (
    <>
      <p class="label" style="text-align:center;margin-bottom:8px">
        Add to calendar
      </p>
      <ul class="cal">
        {cal.google ? (
          <li>
            <a href={cal.google} target="_blank" rel="noopener noreferrer">
              Google
            </a>
          </li>
        ) : null}
        {cal.outlook ? (
          <li>
            <a href={cal.outlook} target="_blank" rel="noopener noreferrer">
              Outlook
            </a>
          </li>
        ) : null}
        {cal.ics ? (
          <li>
            <a href={cal.ics} download>
              Apple / .ics
            </a>
          </li>
        ) : null}
      </ul>
    </>
  );
}

export function JoinButton({ href }: { href: string }) {
  return (
    <a class="btn" href={href}>
      Open your join link
    </a>
  );
}

export function Confirmation(p: ConfirmationProps) {
  return (
    <div class="done" role="status" aria-live="polite">
      <Tick />
      <h2 class="title">{p.title}</h2>
      {p.when ? <p class="when">{p.when}</p> : null}
      {p.subtitle ? (
        <p class="sub">{p.subtitle}</p>
      ) : (
        <p class="sub">Check your email for the details.</p>
      )}
      <CalendarButtons cal={p.calendar} />
      {p.joinUrl ? <JoinButton href={p.joinUrl} /> : null}
      {p.children}
    </div>
  );
}
